import React from 'react';
import { Icon, Carousel, Spin, Tooltip } from 'antd';
import { isEmpty } from 'ramda';
import Context from '../Container/Context';
import api from '../../../config/api';
import { asserts, network, generators } from '../../../utils';
import './SuperService.less';

export default () => {
  const { basicConfig, principal } = React.useContext(Context);
  const { advRollInter = 3000 } = basicConfig;
  const isLoginIn = asserts.isExist(principal);

  const [superList, setSuperList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const fetchList = async () => {
    setLoading(true);
    const res = await network.get(api.home.exclusiveCustSer);
    const { data = {} } = res.data;
    const superList = generators.generatorArray(data.agentList) || [];
    setSuperList(superList);
    setLoading(false);
  };

  React.useEffect(() => {
    if (isLoginIn) {
      fetchList();
    }
  }, [isLoginIn]);

  if (!isLoginIn) return null;
  if (isEmpty(superList)) return null;

  const handleGoNewPage = (item) => {
    if (item.qwAgentLink) {
      window.open(item.qwAgentLink, '_blank');
    }
  };

  return (
    <div className="super-service">
      <Spin spinning={loading}>
        <div className="special-title">
          <Icon type="crown" />
          专属客服
        </div>
        <Carousel
          key={superList.length}
          effect="fade"
          autoplay={superList.length > 1}
          dots={false}
          autoplaySpeed={advRollInter}
          pauseOnDotsHover
        >
          {superList.map((item) => {
            const displayMobile = item.mobile || '';
            return (
              <div key={item.agentId} onClick={() => handleGoNewPage(item)}>
                <div className="special-wrapper">
                  <div className="special-line">
                    <Tooltip
                      title={`企业微信联系 ${item.agentName || ''}${
                        displayMobile ? ` ${displayMobile}` : ''
                      }`}
                    >
                      <span className="qiwei-icon-wrap">
                        <img src={`${process.env.TARGET}static/imgs/qiwei.svg`} alt="企业微信" />
                      </span>
                    </Tooltip>
                    <span className="special-line-name link-underline">{item.agentName}</span>
                    <span>{displayMobile}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      </Spin>
    </div>
  );
};
